import React, { useState, useEffect } from 'react'
import { useDispatch, } from 'react-redux';
import { chatMessageCount } from 'redux/actions/myClaims';
import { useHistory } from 'react-router-dom';

const ChatboxComponent = ({ item, userType }) => {
  let history = useHistory()
  const dispatch = useDispatch();
  const [chatCount, setChatCount] = useState(0)

  useEffect(() => {

    fetchApiForChatMessageCount()

  }, [])

  const fetchApiForChatMessageCount = async () => {

    const token = localStorage.getItem('token');

    let userAuth
    if (userType == "BUYER") {
      if (item.buyerInfo?.locationsId) {
        userAuth = item.buyerInfo.locationsId.toString()
      }
      else {
        userAuth = item.buyerInfo?.locationId
      }
    }

    else if (userType == "SELLER") {
      if (item.sellerInfo?.locationsId) {
        userAuth = item.sellerInfo.locationsId.toString()
      }
      else {
        userAuth = item.sellerInfo?.locationId
      }
    }



    let data = {
      userAuth: userAuth,
      userType: "ADMIN",

    }

    let response = await dispatch(chatMessageCount(data, token));

    if (response && response.status === 'SUCCESS') {
      if (response?.payload?.length) {
        let filterchatmessagecount = response?.payload.find((value) => {
          return value.orderId == item.orderId && value.userTpye == userType
        })

        if (userType == "BUYER") {
          setChatCount(filterchatmessagecount?.unreadMsgCount)
        }

        if (userType == "SELLER") {
          setChatCount(filterchatmessagecount?.unreadMsgCount)
        }
      }

    } else {
      if (response.statusCode === 401) {
        localStorage.removeItem('token')
        history.push('/sign-in')
        window.location.reload(false);
      }
    }

  }

  return (

    <>
      {chatCount > 0 &&
        <div style={{ height: '26px', width: '26px', borderRadius: '13px', background: '#27911b', top: '-20px', position: 'relative', left: '', fontSize: "", textAlign: "center" }}>
          <span title={``} style={{ position: '', left: '', color: 'white', top: '4px' }} onClick={() => {
            setChatCount(0)
          }}>
            {chatCount}

          </span>
        </div>
      }

    </>
  )
}

export default ChatboxComponent
